export default [
    {
        path: '/tenants',
        name: 'Tenants',
        meta: {
            requiresAuth: true,
            allowRoles: null,
            denyRoles: null,
            isCentralRoute: true,
            title: 'Tenants',
        },
        components: {
            default: () => import('@views/tenants/TenantsIndex.vue'),
        },
        children: [],
    },
    {
        path: '/tenants/create',
        name: 'TenantCreate',
        meta: {
            requiresAuth: true,
            allowRoles: null,
            denyRoles: null,
            isCentralRoute: true,
        },
        components: {
            default: () => import('@views/tenants/TenantsCreate.vue'),
        },
    },
    {
        path: '/tenants/:id/edit',
        name: 'TenantEdit',
        props: {
            default: (route) => ({ tenantId: route.params.tenantId }),
        },
        meta: {
            requiresAuth: true,
            allowRoles: null,
            denyRoles: null,
            isCentralRoute: true,
        },
        components: {
            default: () => import('@views/tenants/TenantsEdit.vue'),
        },
    },
];
